<section class="breadcrumb-banner">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <div class="breadcrumb-text">
          <h1>
           G H Raisoni Memorial Pune International FIDE Rapid Rating Chess Tournament
          </h1>
        </div>
      </div>
    </div>
  </div>
  <div class="breadcrumb-bottom-img">
    <img
      src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
    />
  </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
  <div class="container">
    <div class="sec-title text-center mb-5">
      <h2>
        <span
          >3rd G H Raisoni Memorial Pune International FIDE Rapid Rating Chess Tournament 2025</span
        >
      </h2>
    </div>
    <div class="row justify-content-between">
      <div class="col-md-12">
       <p> The 3rd G H Raisoni Memorial Pune International FIDE Rapid Rating Chess Tournament 2025 concluded successfully with a vibrant and well-attended prize distribution ceremony. The event was graced by eminent dignitaries including:</p>
<ul class="list-style list-style1 mb-3">
<li>Shri Niranjan Godbole – Hon. Secretary, Maharashtra Chess Association</li>

<li>Dr. N.B. Hulle – Deputy Director, Raisoni College, Pune</li>

<li>Shri Bhushan Shriwas – Secretary, Kalpana Prakash Welfare Foundation</li>

<li>Shri Rajendra Shidore – Chief Arbiter</li>

<li>Shri S.S. Soman – Member, MCA Observer Committee</li>

<li>Dr. Nishigandha Patil – Sports Incharge, Raisoni College, Pune</li>
</ul>
<p>Earlier, the event was inaugurated at the hands of Shri Arya Mayur Ji, Member of PDCC, along with Dr. R.D. Kharadkar, Director, GHRCEM Pune. Shri Bhushan Shriwas, Shri Rajendra Shidore, and Dr. N.B. Hulle also graced the dais during the inauguration. The entire program was smoothly conducted by Shri S.S. Soman, Member of the MCA Observer Committee.</p>

<p>As a thoughtful gesture, water bottles were distributed to all participants as a token of appreciation.</p>

<p>Congratulations to all the winners!</p>

<h5 class="mt-4">Event Highlights:</h5>
<ul class="list-style list-style1 mb-3">
<li>Total Entries: 350</li>

<li>International Participation: 4 players from 4 federations (USA, Netherlands, Ireland, and France)</li>

<li>FIDE Rated Players: 192</li>

<li>Youngest Participant: Athiyan Llan (Born in 2020), Mumbai</li>

<li>Oldest Participant: Shri Laxman Khude (Born in 1953), Pune</li>

<li>Female Participants: 38</li>

<li>Total Prize Fund: ₹3,00,000/-</li>

<li>Winner’s Prize: ₹51,000/-</li>
</ul>
<p>This prestigious event not only showcased immense national and international chess talent but also provided an excellent opportunity for unrated players to obtain their FIDE ratings.</p>


      </div>
      <div class="col-md-12">
        <div class="sec-title mt-4 text-center">
          <h2><span>Photo Gallery</span></h2>
        </div>
        <div class="lightBox--gallery">
          <ul class="list-unstyled lightgallery justify-content-center row row-cols-1 row-cols-md-4">

            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-1.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-1.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-1.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                  />
                </div>
              </a>
            </li>
            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-2.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-2.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-2.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                  />
                </div>
              </a>
            </li>

            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-3.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-3.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-3.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                  />
                </div>
              </a>
            </li>
            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-4.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-4.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-4.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                  />
                </div>
              </a>
            </li>
            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-5.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-5.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-5.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                  />
                </div>
              </a>
            </li>
             <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                  />
                </div>
              </a>
            </li>
            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-6.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-6.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-6.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                  />
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
